/**
 * One Radix dropdown row, in the app's house menu styling — the `MenuItem`
 * pattern from the inquiries toolbar, re-authored here because features do not
 * import from each other's folders (each has one owning stream; the shared
 * surface is `lib/` and `components/ui`). If a third feature needs it, the
 * right move is promotion into `components/ui`, not a third copy.
 */

import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { cn } from '../../lib/cn';

export function MenuItem({
  children,
  onSelect,
  selected = false,
  disabled = false,
}: {
  children: React.ReactNode;
  onSelect: () => void;
  selected?: boolean;
  disabled?: boolean;
}): React.JSX.Element {
  return (
    <DropdownMenu.Item
      disabled={disabled}
      onSelect={onSelect}
      className={cn(
        'flex cursor-pointer items-center justify-between gap-2 rounded-sm px-2 py-1.5 text-body13 text-fg outline-none',
        'data-[highlighted]:bg-subtle data-[disabled]:cursor-not-allowed data-[disabled]:text-fg-muted',
      )}
    >
      {children}
      {selected ? (
        <span aria-hidden="true" className="text-indigo">
          •
        </span>
      ) : null}
    </DropdownMenu.Item>
  );
}
